module.exports = __webpack_public_path__ + "img/batch-directive-detail.004f368c.png";